<template>
  <div class="app-layout">
    <div class="app-layout__wrapper">
      <div class="project-loader" v-if="isProjectLoading">
        <b-spinner label="Loading..." class="editor-loader"/>
        <div class="project-loader__label">Loading project...</div>
      </div>

      <div v-if="!isProjectLoading">
        <Navigation></Navigation>
        <div class="app-container" :class="{isPlaceOrder: activeNavPath === '/finalize'}">
          <router-view>
            <Canvas slot="canvas"/>
          </router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Canvas from '@/components/canvas/Canvas.vue';
import Navigation from '../components/common/Navigation.vue';

export default {
  name: 'AppLayout',

  components: {
    Canvas,
    Navigation,
  },

  mounted () {
    this.$store.dispatch('auth/handleErrors');
    this.openProject();
  },

  computed: {
    activeNavPath () {
      return this.$store.getters['ui/getActiveNavPath'];
    },

    prices () {
      return this.$store.getters['finalizeOrder/getPrices'];
    },

    jacketPrice () {
      return this.$store.getters['finalizeOrder/getJacketPrice'];
    },

    activeJacketType () {
      return this.$store.getters['design/getJacketType'];
    },

    isLoggedIn () {
      return this.$store.getters['auth/isLoggedIn'];
    },

    isProjectLoading () {
      return this.$store.getters['design/isProjectLoading'];
    }
  },

  watch: {
    activeJacketType () {
      this.$store.dispatch('finalizeOrder/calculateJacketPrice');
    },

    isLoggedIn (value) {
      if (!value) {
        this.$router.push({ path: '/login', query: this.$route.query });
      }
    }
  },

  methods: {
    openProject () {
      this.$store.dispatch('design/setLoadingProject', true);
      const colorsPromise = this.getColors();
      const pricePromise = this.getPrices();
      const specialColorsPromise = this.getSpecialSchoolColors();

      Promise.all([colorsPromise, pricePromise, specialColorsPromise]).then(() => {
        this.$store.dispatch('design/loadProject', {
          designedJacketId: this.$route.query.designedJacketId,
          orderId: this.$route.query.orderId,
          userId: this.$route.query.userId,
          schoolId: this.$route.query.schoolId
        }).then(() => {
          this.$store.dispatch('finalizeOrder/calculateTotalPrice');
          this.$store.dispatch('design/setLoadingProject', false);
        });
      });
    },

    getColors () {
      return this.$store.dispatch('elements/getColors').then((data) => {
        this.$store.commit('design/setBodyColor', { color: data.jacketBodyColors[2] });
        this.$store.commit('design/setSleevesColor', { color: data.sleevesColors[0] });
        this.$store.commit('design/setPocketsColor', { color: data.sleevesColors[0] });
        this.$store.commit('design/setSnapsColor', { color: data.snapsColors[0] });
        this.$store.commit('design/setBaseTrimColor', { color: data.trimColors[2] });
        this.$store.commit('design/setSecondaryTrimColor', { color: data.trimColors[0] });
        this.$store.commit('design/setFinishTrimColor', { color: data.trimColors[1] });
        this.$store.commit('design/setInsideCollarColor', { color: data.jacketBodyColors[0] });
        return data;
      });
    },

    getSpecialSchoolColors () {
      if (this.$route.query.schoolId) {
        return this.$store.dispatch('elements/getSpecialColors', this.$route.query.schoolId).then((data) => {
          const schoolColors = {
            aHex: data.colorOne ? data.colorOne : 'static',
            bHex: data.colorTwo ? data.colorTwo : 'static',
          };

          // this.$store.commit('design/setBodyColor', { color: data.bodyColor });
          // this.$store.commit('design/setSecondaryTrimColor', { color: data.secondaryColor });
          this.$store.commit('elements/setSchoolColors', schoolColors);
          this.$store.dispatch('design/setSchoolColorsTags', schoolColors);
        });
      }

      return true;
    },

    getPrices () {
      return this.$store.dispatch('finalizeOrder/getPrices');
    },
  }
};
</script>

<style scoped>
  .app-container.isPlaceOrder {
    height: auto;
  }

  .app-container {
    height: 700px;
    padding: 15px;
    position: relative;
  }

  .project-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
</style>
